import { render, staticRenderFns } from "./span-phone-number.vue?vue&type=template&id=313e7d99&"
import script from "./span-phone-number.vue?vue&type=script&lang=js&"
export * from "./span-phone-number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports